<script setup lang="ts">
import { useIubendaStore } from "@/store/iubenda";
import type { PagePrivacy } from "@/.storyblok/types/120421/storyblok-components";

const props = defineProps<{
  blok: PagePrivacy;
}>();

const iubendaStore = useIubendaStore();
const { locale } = useI18n();

watch(
  () => locale.value,
  async () => {
    await iubendaStore.fetchIubendaData();
  }
);

useHead({
  meta: [
    { name: "robots", content: "noindex, follow" }
  ],
});

useSeoMeta({
  title: props.blok.seoTitle,
  description: props.blok.seoDescription,
});

onServerPrefetch(async () => {
  if (!iubendaStore.dataPrivacy) {
    await iubendaStore.fetchIubendaData();
  }
});

onMounted(async () => {
  if (!iubendaStore.dataPrivacy) {
    await iubendaStore.fetchIubendaData();
  }
});
</script>

<template>
  <section v-editable="blok">
    <StoryblokComponent
      v-for="blokEntry in blok.body"
      :key="blokEntry._uid"
      :blok="blokEntry"
    />
  </section>
  <BaseContentSection background-color="light">
    <div class="prose lg:prose-lg" v-html="iubendaStore.dataPrivacy"></div>
  </BaseContentSection>
</template>
